import constants from '../constants';

export const onChange = (name, value) => ({
  type: constants.ON_CHANGE,
  payload: { name, value },
});

export const highlightErrors = (errors, name) => ({
  type: constants.HIGHLIGHT_ERRORS,
  payload: { errors, name },
});

export const onSubmitSuccess = () => ({
  type: constants.PROMISE_SUBMIT_SUCCESS,
});

export const onSubmitError = () => ({
  type: constants.PROMISE_SUBMIT_ERROR,
});

export const setReadyToSubmit = isReady => ({
  type: constants.SET_READY_FOR_SUBMIT,
  payload: isReady,
});
